class CustomPopUp extends HTMLElement {
    connectedCallback() {
        this.overlay = this.overlayElement
        this.closeButton = this.closeButtonElement

        this.settings = {
            trigger: this.dataset.trigger,
            visibility: this.dataset.visibility,
            delay: parseInt(this.dataset.delay) || 0
        }

        if (this.shouldShow()) {
            setTimeout(() => this.show(), this.settings.delay * 1000)
        }

        this.closeButton.addEventListener('click', this.hide.bind(this))
        this.overlay?.addEventListener('click', this.hide.bind(this))

        document.addEventListener('shopify:section:select', (e) => {
            if (e.detail.sectionId === this.id) this.show()
        })

        document.addEventListener('shopify:section:deselect', (e) => {
            if (e.detail.sectionId === this.id) this.hide()
        })
    }

    shouldShow() {
        if (this.settings.trigger === 'url_specific') {
            let targetURL

            try {
                targetURL = new URL(this.dataset.visibleOnUrl, window.location.origin)
            } catch {
                return false;
            }

            if (!targetURL) return false
            if (!window.location.pathname.includes(targetURL.pathname)) return false
        }

        if (this.settings.visibility === 'once' && this.wasSeen()) return false
        if (this.settings.visibility === 'session' && this.wasSeenThisSession()) return false
        return true
    }

    wasSeen() {
        return localStorage.getItem(`pop-up-seen:${this.id}`) === 'true'
    }

    wasSeenThisSession() {
        return sessionStorage.getItem(`pop-up-seen:${this.id}`) === 'true'
    }

    markAsSeen() {
        if (this.settings.visibility === 'once') {
            localStorage.setItem(`pop-up-seen:${this.id}`, 'true')
        } else if (this.settings.visibility === 'session') {
            sessionStorage.setItem(`pop-up-seen:${this.id}`, 'true')
        }
    }

    get overlayElement() {
        return this.nextElementSibling?.id === 'customPopUpOverlay' ? this.nextElementSibling : null
    }

    get closeButtonElement() {
        return this.querySelector('pop-up-close')
    }

    show() {
        this.classList.add('shown')
        this.setAttribute('aria-hidden', 'false')
        this.overlay?.classList.add('visible')
        if (this.settings.visibility) this.markAsSeen()
    }

    hide() {
        this.classList.remove('shown')
        this.overlay?.classList.remove('visible')
        this.setAttribute('aria-hidden', 'true')
    }
}

customElements.define('custom-pop-up', CustomPopUp)